import React from 'react';
import ContentLoader from 'react-content-loader';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = () =>
  createStyles({
    wrapper: { width: '300px' },
  });

interface ContentLoaderPatientContactProps extends WithStyles<typeof styles> {}

const ContentLoaderPatientContact = ({ classes }: ContentLoaderPatientContactProps) => (
  <div className={classes.wrapper}>
    <ContentLoader width={200} height={8}>
      <rect x="5" rx="2" ry="2" width="200" height="8" />
    </ContentLoader>
  </div>
);

export default withStyles(styles)(ContentLoaderPatientContact);
